import React from "react";
import LeagueMatches from "./LeagueMatches";
import { transformDataByRound } from "../../../utils/generalLiveCenter";
import CricketLeagueMatches from "../../cricket/league/CricketLeagueMatches";

const InfoTab = ({
  response,
  children,
  baseUrl,
  websiteBaseUrl,
  dataPath,
  id,
  matchType,
  dataClient,
  sport = "football",
  difference,
}) => {
  const upComingsNewData = response?.upcoming;
  const lastMatchNewData = response?.last;


  let lastMatchData;
  if (lastMatchNewData?.length === undefined) {
    const data = transformDataByRound(lastMatchNewData);
    lastMatchData = data?.data;
  } else {
    lastMatchData = lastMatchNewData;
  }

  let upComingsData;
  if (upComingsNewData?.length === undefined) {
    const data = transformDataByRound(upComingsNewData);
    upComingsData = data?.data;
  } else {
    upComingsData = upComingsNewData;
  }

  const renderLeagueBoxes = (matchesData, teamid) => {
    if (!matchesData || matchesData?.length === 0) {
      return <p>No matches found</p>;
    } else {
      return (
        <React.Fragment>
          {sport === "football" || sport === "rugby" ? (
            <LeagueMatches
              finalData={matchesData}
              matchType={matchType}
              sport={sport}
              baseUrl={baseUrl}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              updatedData={true}
              dataClient={dataClient}
              Result={matchType !== "league" && teamid}
              teamid={teamid || ""}
              difference={difference}

            />
          ) : (
            <>
              <CricketLeagueMatches
                finalData={matchesData}
                matchType={matchType}
                sport={sport}
                baseUrl={baseUrl}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                updatedData={true}
                dataClient={dataClient}
                tournamentListing={matchType !== "team" ? "tournamentListing" : "team"}
                difference={difference}

              />
            </>
          )}
        </React.Fragment>
      );
    }
  };

  return (
    <div className="info_main_box">
      {upComingsData?.length > 0 && (
        <div>
          <h2>Upcoming</h2>
          {renderLeagueBoxes(upComingsData)}
        </div>
      )}

      {lastMatchData?.length > 0 && (
        <div>
          <h2>Latest Scores</h2>
          {renderLeagueBoxes(lastMatchData, id)}
        </div>
      )}

      {children}
    </div>
  );
};

export default InfoTab;
